import React from 'react';

// Conjunto mínimo de ícones em linha (sem dependência nova), no lugar dos
// emojis do protótipo. Todos em traço (stroke), 24x24, cor herdada do texto.
const PATHS = {
  logo: (
    <>
      <rect x="3" y="3" width="18" height="18" rx="6" />
      <circle cx="12" cy="12" r="2.4" fill="currentColor" stroke="none" />
    </>
  ),
  search: <><circle cx="11" cy="11" r="7" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></>,
  // Três traços do botão que abre o menu no celular (Topbar).
  menu: <><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" /></>,
  grid: (
    <>
      <rect x="3" y="3" width="7" height="7" rx="1.2" />
      <rect x="14" y="3" width="7" height="7" rx="1.2" />
      <rect x="3" y="14" width="7" height="7" rx="1.2" />
      <rect x="14" y="14" width="7" height="7" rx="1.2" />
    </>
  ),
  inbox: (
    <>
      <rect x="3" y="8" width="18" height="12" rx="2" />
      <polyline points="3 8 8 8 10 12 14 12 16 8 21 8" />
    </>
  ),
  activity: <path d="M12 2a10 10 0 1 0 10 10" />,
  list: (
    <>
      <line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" />
      <line x1="3" y1="6" x2="3.01" y2="6" /><line x1="3" y1="12" x2="3.01" y2="12" /><line x1="3" y1="18" x2="3.01" y2="18" />
    </>
  ),
  columns: (
    <>
      <rect x="3" y="4" width="5" height="16" rx="1.2" />
      <rect x="9.5" y="4" width="5" height="10" rx="1.2" />
      <rect x="16" y="4" width="5" height="13" rx="1.2" />
    </>
  ),
  'corner-up-left': <><polyline points="9 14 4 9 9 4" /><path d="M20 20v-7a4 4 0 0 0-4-4H4" /></>,
  award: <><circle cx="12" cy="8" r="5" /><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88" /></>,
  history: <><circle cx="12" cy="12" r="9" /><polyline points="12 7 12 12 15 14" /></>,
  users: (
    <>
      <circle cx="9" cy="8" r="3.2" />
      <path d="M3.5 20c0-3.5 2.9-6 5.5-6s5.5 2.5 5.5 6" />
      <circle cx="17" cy="9" r="2.6" />
      <path d="M15.6 14.3c1.9.6 3.2 2.3 3.4 5.7" />
    </>
  ),
  send: <><line x1="22" y1="2" x2="11" y2="13" /><polygon points="22 2 15 22 11 13 2 9 22 2" /></>,
  settings: <><circle cx="12" cy="12" r="8" strokeDasharray="2.6 3" /><circle cx="12" cy="12" r="2.5" /></>,
  'help-circle': (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.5 9a2.5 2.5 0 1 1 3.5 2.3c-.8.4-1.3 1.1-1.3 2" />
      <circle cx="12" cy="17" r="0.4" fill="currentColor" stroke="none" />
    </>
  ),
  bell: <><path d="M6 8a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6" /><path d="M10 20a2 2 0 0 0 4 0" /></>,
  moon: <path d="M20 14.5A8.5 8.5 0 1 1 9.5 4a7 7 0 0 0 10.5 10.5z" />,
  sun: (
    <>
      <circle cx="12" cy="12" r="4.2" />
      <line x1="12" y1="1" x2="12" y2="4" /><line x1="12" y1="20" x2="12" y2="23" />
      <line x1="1" y1="12" x2="4" y2="12" /><line x1="20" y1="12" x2="23" y2="12" />
      <line x1="18.4" y1="5.6" x2="20.5" y2="3.5" /><line x1="5.6" y1="5.6" x2="3.5" y2="3.5" />
      <line x1="18.4" y1="18.4" x2="20.5" y2="20.5" /><line x1="5.6" y1="18.4" x2="3.5" y2="20.5" />
    </>
  ),
  'log-out': <><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" /></>,
  'refresh-cw': (
    <>
      <polyline points="23 4 23 10 17 10" /><polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </>
  ),
  // ATUALIZAÇÃO DO APLICATIVO — nuvem com seta para baixo.
  //
  // Antes este botão usava o 'refresh-cw' (duas setas em círculo), colado ao
  // 'rotate-cw' (uma seta) de "atualizar os dados": dois círculos de setas lado
  // a lado na mesma barra, e ninguém sabia qual recarregava a tela e qual
  // baixava versão nova. Buscar versão é DOWNLOAD, e é isso que o desenho
  // passa a dizer — nada a ver com recarregar a página.
  'cloud-download': (
    <>
      <path d="M17.5 17.5a4.5 4.5 0 0 0-1.2-8.84 6 6 0 0 0-11.5 1.6A3.75 3.75 0 0 0 5.5 17.5" />
      <polyline points="9 15 12 18 15 15" />
      <line x1="12" y1="11" x2="12" y2="18" />
    </>
  ),
  // Uma volta só — atualizar OS DADOS. Distinto do 'cloud-download',
  // que na topbar significa procurar uma nova versão DO APP.
  'rotate-cw': (
    <>
      <polyline points="21 4 21 10 15 10" />
      <path d="M20.49 15a9 9 0 1 1-2.12-9.36L21 10" />
    </>
  ),
  'chevron-left': <polyline points="15 18 9 12 15 6" />,
  'chevron-right': <polyline points="9 18 15 12 9 6" />,
  // Par do 'chevron-right' para o que abre PARA BAIXO (detalhe de relatório).
  'chevron-down': <polyline points="6 9 12 15 18 9" />,
  plus: <><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></>,
  clock: <><circle cx="12" cy="12" r="9" /><polyline points="12 7 12 12 15 14" /></>,
  lock: <><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></>,
  // Clipe — anexar arquivo a um campo de texto.
  paperclip: <path d="M21.44 11.05l-9.19 9.19a5.5 5.5 0 0 1-7.78-7.78l9.19-9.19a3.5 3.5 0 1 1 4.95 4.95L9.4 17.43a1.5 1.5 0 0 1-2.12-2.12l8.49-8.49" />,
  tag: <><path d="M20.59 13.41 11 3.83A2 2 0 0 0 9.58 3.25H4a1 1 0 0 0-1 1v5.59a2 2 0 0 0 .58 1.42l9.58 9.58a2 2 0 0 0 2.83 0l6.6-6.6a2 2 0 0 0 0-2.83z" /><circle cx="7.5" cy="7.5" r="1.2" fill="currentColor" stroke="none" /></>,
  zap: <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />,
  x: <><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></>,
  check: <polyline points="20 6 9 17 4 12" />,
  /* Passo ainda não iniciado — o contorno vazio diz 'na fila', sem parecer erro. */
  circle: <circle cx="12" cy="12" r="7" />,
  filter: <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />,
  download: <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></>,
  globe: <><circle cx="12" cy="12" r="9" /><ellipse cx="12" cy="12" rx="4" ry="9" /><line x1="3" y1="12" x2="21" y2="12" /></>,
  monitor: <><rect x="2" y="3" width="20" height="14" rx="2" /><line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" /></>,
  box: (
    <>
      <polygon points="12 2 3 7 3 17 12 22 21 17 21 7 12 2" />
      <line x1="3" y1="7" x2="12" y2="12" /><line x1="12" y1="12" x2="21" y2="7" /><line x1="12" y1="12" x2="12" y2="22" />
    </>
  ),
  code: <><polyline points="16 18 22 12 16 6" /><polyline points="8 6 2 12 8 18" /></>,
  compass: <><circle cx="12" cy="12" r="9" /><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" /></>,
  layers: (
    <>
      <polygon points="12 2 2 7 12 12 22 7 12 2" />
      <polyline points="2 17 12 22 22 17" />
      <polyline points="2 12 12 17 22 12" />
    </>
  ),
  user: <><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4.4 3.6-7 8-7s8 2.6 8 7" /></>,
  'file-text': (
    <>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
      <polyline points="14 3 14 8 19 8" />
      <line x1="9" y1="13" x2="15" y2="13" /><line x1="9" y1="17" x2="15" y2="17" />
    </>
  ),
  'alert-triangle': (
    <>
      <polygon points="12 3 22 20 2 20" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <circle cx="12" cy="16.3" r="0.6" fill="currentColor" stroke="none" />
    </>
  ),
  target: <><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5.2" /><circle cx="12" cy="12" r="1.4" fill="currentColor" stroke="none" /></>,
  'trending-up': <><polyline points="3 17 9 11 13 15 21 6" /><polyline points="15 6 21 6 21 12" /></>,
  maximize: <rect x="4" y="4" width="16" height="16" rx="2" />,
  // Setas para os cantos: "abrir maior" — usada na borda das caixas de texto.
  expand: (
    <>
      <polyline points="14 4 20 4 20 10" /><polyline points="10 20 4 20 4 14" />
      <line x1="20" y1="4" x2="13.5" y2="10.5" /><line x1="4" y1="20" x2="10.5" y2="13.5" />
    </>
  ),
  restore: <><rect x="7" y="7" width="13" height="13" rx="2" /><path d="M4 15V6a2 2 0 0 1 2-2h9" /></>,
  trash: <><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></>,
  // caneta de marcação e cópia — usados na janela do anexo (ImagemApp)
  pen: <><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7.5 18.5 3 20l1.5-4.5z" /><line x1="14.5" y1="5.5" x2="18.5" y2="9.5" /></>,
  copy: <><rect x="9" y="9" width="11" height="11" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></>,
  'shield-check': <><path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z" /><polyline points="9 12 11 14 15 10" /></>,
  'check-square': <><polyline points="9 11 12 14 17 9" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" /></>,
  package: <><path d="M21 16V8l-9-5-9 5v8l9 5 9-5z" /><polyline points="3.3 7.5 12 12.5 20.7 7.5" /><line x1="12" y1="12.5" x2="12" y2="21" /></>,

  // ── Acrescentados para o Orion ──
  // O Nexus não precisava destes: são a janela sem moldura (minimizar/fechar),
  // a gravação de áudio da formalização e os anexos do chamado de T.I.
  minimize: <><line x1="5" y1="12" x2="19" y2="12" /></>,
  mic: <><rect x="9" y="2" width="6" height="12" rx="3" /><path d="M5 11a7 7 0 0 0 14 0" /><line x1="12" y1="18" x2="12" y2="22" /></>,
  'mic-off': <><line x1="3" y1="3" x2="21" y2="21" /><path d="M9 5a3 3 0 0 1 6 0v5m-6 1a3 3 0 0 0 4.5 2.6" /><path d="M5 11a7 7 0 0 0 10.5 6" /><line x1="12" y1="18" x2="12" y2="22" /></>,
  play: <><polygon points="6 4 20 12 6 20 6 4" /></>,
  stop: <><rect x="6" y="6" width="12" height="12" rx="1.5" /></>,
  image: <><rect x="3" y="4" width="18" height="16" rx="2" /><circle cx="8.5" cy="9.5" r="1.6" /><polyline points="21 16 16 11 5 20" /></>,
  eye: <><path d="M2 12s3.6-6 10-6 10 6 10 6-3.6 6-10 6-10-6-10-6z" /><circle cx="12" cy="12" r="2.6" /></>,
  'message-square': <><path d="M21 15a2 2 0 0 1-2 2H8l-4 4V5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2z" /></>,
  folder: <><path d="M3 7a2 2 0 0 1 2-2h4l2 2.5h8a2 2 0 0 1 2 2V18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /></>,
  ticket: <><path d="M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v1.5a2 2 0 0 0 0 3.8V16a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1.7a2 2 0 0 0 0-3.8z" /><line x1="13" y1="7" x2="13" y2="18" strokeDasharray="2 2.5" /></>,
  upload: <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 9 12 4 17 9" /><line x1="12" y1="4" x2="12" y2="16" /></>,
  bug: <><rect x="8" y="7" width="8" height="12" rx="4" /><line x1="3" y1="11" x2="8" y2="11" /><line x1="16" y1="11" x2="21" y2="11" /><line x1="4" y1="17" x2="8" y2="15" /><line x1="16" y1="15" x2="20" y2="17" /><line x1="4" y1="6" x2="8" y2="8" /><line x1="16" y1="8" x2="20" y2="6" /><path d="M9.5 7a2.5 2.5 0 0 1 5 0" /></>,
  save: <><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" /><polyline points="17 21 17 13 7 13 7 21" /><polyline points="7 3 7 8 15 8" /></>,
  'alert-circle': <><circle cx="12" cy="12" r="9" /><line x1="12" y1="8" x2="12" y2="12.5" /><line x1="12" y1="16" x2="12.01" y2="16" /></>,
  'file-plus': <><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="12" y1="12" x2="12" y2="18" /><line x1="9" y1="15" x2="15" y2="15" /></>,
  coffee: <><path d="M3 8h13v6a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4z" /><path d="M16 9h2a2.5 2.5 0 0 1 0 5h-2" /><line x1="6" y1="2" x2="6" y2="5" /><line x1="10" y1="2" x2="10" y2="5" /><line x1="14" y1="2" x2="14" y2="5" /></>,
  // O prédio marca o CLIENTE na ficha do ticket — pessoa (`user`) é o
  // solicitante, empresa é outra coisa, e o par só fica legível se os dois
  // desenhos forem diferentes.
  building: (
    <>
      <path d="M4 21V5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v16" />
      <path d="M15 9h3a2 2 0 0 1 2 2v10" />
      <line x1="2.5" y1="21" x2="21.5" y2="21" />
      <line x1="7.5" y1="7.5" x2="9.5" y2="7.5" /><line x1="7.5" y1="11.5" x2="9.5" y2="11.5" />
      <line x1="7.5" y1="15.5" x2="9.5" y2="15.5" />
    </>
  ),
  // Barras crescentes: a CRITICIDADE é uma escala de 1 a 5, e a altura das
  // barras diz isso sem precisar ler o número.
  'bar-chart': (
    <>
      <line x1="5" y1="20" x2="5" y2="13" /><line x1="12" y1="20" x2="12" y2="8" />
      <line x1="19" y1="20" x2="19" y2="4" />
    </>
  ),
  // Folha com uma faísca no canto: as notas de versão — o mesmo desenho do Nexus.
  'release-notes': (
    <>
      <path d="M13.5 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7.5" />
      <line x1="9" y1="12.5" x2="14.5" y2="12.5" /><line x1="9" y1="16.5" x2="13" y2="16.5" />
      <path d="M18 2.2l.95 2.15 2.15.95-2.15.95L18 9.4l-.95-2.15-2.15-.95 2.15-.95z" />
    </>
  ),
};

export default function Icon({ name, size = 16, strokeWidth = 1.8, className = '', style, title }) {
  const content = PATHS[name];
  if (!content) return null;
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke="currentColor" strokeWidth={strokeWidth}
      strokeLinecap="round" strokeLinejoin="round"
      className={`orion-icon ${className}`}
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0, ...style }}
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
    >
      {title && <title>{title}</title>}
      {content}
    </svg>
  );
}
